<template>
  <div id="app">
    <Header />
    <v-wait for="loading.*">
      <template slot="waiting">
        <div class="loading-layer">
          <div class="lds-ring">
            <div></div>
            <div></div>
          </div>
        </div>
      </template>
    </v-wait>
    <router-view />
    <Footer />
    <div id="qservus-widget-container"></div>
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import axios from 'axios'
import wait from '@/wait'
import config from "@/config";
import {
  log
} from '@/logging';

export default {
  components: { Header, Footer },
  methods: {
    error: function(method, error){
      log.error("Error trying to " + "[" + method + "] " + error);
      this.errorMS = true;
      wait.end("loading.everything");
      window.digitalData = {};
      window.dataLayer.push({'event':'cargaErrorPago',});
    },
    async getOauthToken() {
       wait.start("loading.everything");
      try{
        const response = await axios.get(config.endpoints.oauthToken);
        if (response.status === 200 && response.data.statusCode === 200 && response.data.body !== undefined) {
            log.info("getOauthToken true!");
            const tokenOauth = response.data.body;
            this.$store.getters.tokenOauth = tokenOauth;
            if(this.$store.getters.billingInfo.customerIdentificationNumber != null 
            || this.$store.getters.billingInfo.customerIdentificationNumber != undefined){
                this.getCurtain(tokenOauth, this.$store.getters.billingInfo.customerIdentificationNumber);
            }
        } else {
          this.error("getOauthToken", "");
        }
      }catch(e){
        this.error("getOauthToken", e);
      }
    },
    async getCurtain(tokenOauth, rut) {
      const params = {
          canal: "PP",
          rut: rut
      };
      const headers = { 
        Authorization: "Bearer " + tokenOauth,
      };
      try{
        const response = await axios.get(config.endpoints.curtain + '?rut='+params.rut+'&canal='+params.canal,  { headers });
        if (response.status === 200 && response.data.status === 200  && response.data.data !== undefined) {
          log.info("getCurtain true!");

          if (response.data.data[0].activa){
            this.$router.push({
              path: '/curtain'
            });
          }
        
          wait.end("loading.everything");
        } else {
          this.error("getCurtain", "");
        }
      }catch(e){
        this.error("getCurtain", e);
      }
    }
  },
  created(){
    if(window.location.hostname.includes("localhost")){
      this.getCurtain("", this.$store.getters.billingInfo.customerIdentificationNumber);
    }else{
      this.getOauthToken();
    }
    window.dataLayer = window.dataLayer || [];
  },

  


};
</script>
<style lang="scss" scoped>
@import "@/style/main.scss";
</style>
